//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The classification of how a scheduled attendance instance matches the preference of the individual. */
export const ScheduledAttendanceItemMatchesPreference = {
    /** Person (group member) has a scheduling preference for the selected schedule and location. */
    MatchesPreference: 0,

    /** Person (group member) has a scheduling preference for a different schedule (or the selected schedule but different location). */
    NotMatchesPreference: 1,

    /** Person (group member) has no scheduling preferences for the group (or the person isn't a member of the group ). */
    NoPreference: 2
} as const;

/** The classification of how a scheduled attendance instance matches the preference of the individual. */
export const ScheduledAttendanceItemMatchesPreferenceDescription: Record<number, string> = {
    0: "Matches Preference",

    1: "Not Matches Preference",

    2: "No Preference"
};

/** The classification of how a scheduled attendance instance matches the preference of the individual. */
export type ScheduledAttendanceItemMatchesPreference = typeof ScheduledAttendanceItemMatchesPreference[keyof typeof ScheduledAttendanceItemMatchesPreference];
